import React from "react";
import "./AboutUs.css";
import { Row, Col } from "react-bootstrap";
import Layout from "../../HOC/Layput/Layout";
const About = () => {
  document.title = "VK Global Publications | About Us"
  return (
    <div>
      <p>
        Established in 1979, VK Global Publications Pvt. Ltd. was founded by the
        renowned academician, Prof. T.R. Jain, who devoted his lifetime to the
        teaching and writing of Economics. With more than four decades of
        leadership in the area of Economics and Commerce, we are now a household
        name; a modest but rather gratifying claim that has made us a pioneer
        Publication House in India.
      </p>
      <p>
        Despite specialising in the area of Economics and Commerce, we are not
        averse to the idea of diversification. With a portfolio spanning the
        Board of School Education, Punjab, Himachal Pradesh, Haryana, Jharkhand
        and Jammu & Kashmir, our educational footprint across India is immense.
        Moreover, the vast readership of our books at the university level
        (Punjab, H.P., Haryana, Rajasthan, Bihar and Delhi Universities in
        particular) is a credible achievement of our publication house. In the
        area of children’s books, Future Kids Publications is our business
        offshoot that has earned tremendous international acclaim. Display of
        our books at the International Book Fair in Frankfurt, Germany since
        2006 has earned us accolades amongst our international community of
        readers.
      </p>
      <p>
        This success of our publication is attributed to our prolific writers
        and we pride ourselves on our reputed authors who bring out the best of
        the study material, making our readers versatile in their thought
        process and equipping them with an exam-oriented acumen. Thousands of
        acknowledgements and appreciations that we receive every year from our
        readers remain a good testimony to the sincere efforts of our authors.
      </p>
      <p>
        However, success of our publication is admittedly due to prudent
        prolific writers. We have resource-pool of reputed authors who leave no
        stone unturned in bringing out the best of study material which makes
        our readers versatile in their thought process and equips them with the
        exam-oriented acumen. Thousands of acknowledgements and appreciations
        that we receive every year from our readers are a good testimony to the
        sincere efforts and ardent endeavours of our authors.
      </p>
      <p>
        We believe in the strength of academic interaction programmes and
        organise them on a routine affair. Through such programmes, our authors
        freely interact with subject teachers from all parts of the country and
        abroad. Thus, facilitating the redressal of questions and queries by the
        readers and serving as a rich source of new ideas for our writers. We
        also believe in constantly updating our resource pool with fresh talent
        and provide welcome access to freelancing lecturers and professors, keen
        to contribute to our academic exercise of writing and designing study
        material in different subjects.
      </p>
      <Row >
        <Col className="about-section first-container" xs = {12} sm={12} md = {12} lg = {6}>
          <Row>
            <Col sm={12} className="mission">
              <h3>Mission</h3>
              <p>
                Our mission is to become the preferred source of knowledge and
                to support the quest of education and lifelong learning at all
                levels. The learning resources and services provided by us are
                carefully selected and situate to meet the diverse needs of the
                individuals and institutions we serve.
              </p>
              <p className="secondHeading ">
                To achieve this mission, we will:
              </p>
              <ul>
                <li>
                  Leverage the full, multi-disciplinary resources of the
                  company.
                </li>
                <li>Perpetuate a great workplace culture</li>
                <li>
                  Continue to advance the firm's leadership position and grow
                  market share in core markets
                </li>
                <li>
                  Be flexible and entrepreneurial in order to take advantage of
                  new and emerging markets
                </li>
              </ul>
            </Col>
          </Row>
        </Col>

        <Col className="about-section second-container"  xs = {12} sm={12} md = {12} lg = {6}>
          <Row>
            <Col sm={12} className="mission vision">
              <h3>Vision</h3>
              <ul>
                <li>
                  To create confidence in all our users, by providing and
                  facilitating accurate, up-to-date, inspiring material and new
                  techniques for learning, knowledge and teaching
                </li>
                <li>To deliver expert, up-to-date knowledge for all</li>
                <li>To be a source for life-long learning</li>
                <li>
                  To instill the virtue of reading and promote quality culture
                  for lifelong best practices
                </li>
                <li>
                  To bring together gurus from all parts of the world to
                  generate a noteworthy ecology of knowledge that will benefit
                  academics and practitioners
                </li>
                <li>To show respect for our planet and all its inhabitants</li>
              </ul>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col className="driveusSection driveusContainer mt-1" xs = {12} sm={12} md = {12} lg = {12}>
          <h3>What Drives Us</h3>
          <ul>
            <li>
              To help all our users to become confident and educated global
              citizens
            </li>
            <li>
              To be the preferred resource for people seeking and sharing
              knowledge and understanding
            </li>
            <li>
              To be brave, decent and imaginative in everything we do and have a
              long standing commitment to high standards of product quality
            </li>
            <li>
              We want each ingredient used in each stage of our products and
              services to be in the best possible shape in can be - and that
              means employing the best, most creative minds as well as using the
              most responsibly sourced supplies available
            </li>
          </ul>
        </Col>
      </Row>
      <br />
    </div>
  );
};

export default Layout(About, "About Us");
